module.exports = __webpack_public_path__ + "static/media/math-practice.6211b91c.png";